import emailjs from '@emailjs/browser';

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_tf1v9fj';
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'template_s2ko01u';
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'L1pBiPT5LQQN13B5P';

const RECIPIENT_EMAIL = 'info@via-medica-balkan.de';

export interface EmailInquiryPayload {
  inquiryType: 'Bewerbung (Pflegekraft)' | 'Anfrage (Arbeitgeber)';
  fromName: string;
  fromEmail?: string;
  phone?: string;
  message?: string;
  details?: string;
}

export const canSendEmailNotifications = () => {
  return Boolean(
    SERVICE_ID &&
    TEMPLATE_ID &&
    PUBLIC_KEY &&
    !TEMPLATE_ID.startsWith('__ejs-test-')
  );
};

export const getEmailConfigError = () => {
  if (!SERVICE_ID || !PUBLIC_KEY) {
    return 'EmailJS Service oder Public Key fehlt.';
  }
  if (!TEMPLATE_ID) {
    return 'EmailJS Template ID fehlt.';
  }
  if (TEMPLATE_ID.startsWith('__ejs-test-')) {
    return 'Bitte eine echte EmailJS Template-ID verwenden (nicht __ejs-test-mail-service__).';
  }
  return '';
};

export const sendInquiryNotificationEmail = async (payload: EmailInquiryPayload) => {
  if (!canSendEmailNotifications()) {
    throw new Error(getEmailConfigError() || 'EmailJS ist nicht vollständig konfiguriert.');
  }

  const templateParams = {
    email: RECIPIENT_EMAIL,
    from_name: payload.fromName || 'Unbekannt',
    from_email: payload.fromEmail || '',
    reply_to: payload.fromEmail || '',
    inquiry_type: payload.inquiryType,
    phone: payload.phone || '',
    message: payload.message || '',
    details: payload.details || '',
    submitted_at: new Date().toLocaleString('de-DE'),
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
};
